import script from "./Subpage3.vue?vue&type=script&setup=true&lang=js"
export * from "./Subpage3.vue?vue&type=script&setup=true&lang=js"

import "./Subpage3.vue?vue&type=style&index=0&id=7e174c58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e174c58"]])

export default __exports__